import styled from 'styled-components';
import { ReactComponent as CrossIcon } from 'src/assets/cross.svg';

export const Icon = styled(CrossIcon)`
  fill: ${({ theme }) => theme.colors.cflowerBlue};
  transition: fill 0.15s ease;
`;

export const Button = styled.button`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: 0;
  border-radius: 6px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background-color: ${({ theme }) => theme.colors.cultured};

    ${Icon} {
      fill: ${({ theme }) => theme.colors.gp1};
    }
  }
`;
